import connections from "@/http/requests/connections"

export default {
    async getAllConnections({ commit }, data) {
        try {
            return new Promise((resolve, reject) => {
                connections.getAllConnections(data.tenantName, data.token)
                .then((response) => {
                    commit('setConnections', response.data);
                    resolve(response);
                })
                .catch((Exception) => { reject(Exception); });
            });

        } catch(Exception) {
            console.log(Exception);
            throw Exception;
        }
    },
    async deleteInstance({ commit }, data) {
        try {
            return new Promise((resolve, reject) => {
                connections.deleteInstance(data.id, data.token, data.tenantName)
                  .then((response) => { resolve(response); })
                  .catch((Exception) => { reject(Exception); });
            });
        } catch(Exception) {
            console.log(Exception);
            throw Exception;
        }
    },
    async restartInstance({ commit }, data) {
        try {
            return new Promise((resolve, reject) => {
                connections.restartInstance(data.id, data.token, data.tenantName)
                  .then((response) => { resolve(response); })
                  .catch((Exception) => { reject(Exception); });
            });
        } catch(Exception) {
            console.log(Exception);
            throw Exception;
        }
    },
    async generateNewToken({ commit }, data) {
        try {
            return new Promise((resolve, reject) => {
                connections.generateNewToken(data.id, data.token, data.tenantName)
                  .then((response) => { resolve(response); })
                  .catch((Exception) => { reject(Exception); });
            });
        } catch(Exception) {
            console.log(Exception);
            throw Exception;
        }
    }
}
